<template>
  <div class="add">
    <header-bar :is-user="true"></header-bar>
    <user-head></user-head>
    <section class="main" v-if="userToken">
      <h1 class="title">发视频</h1>
      <el-form
        :model="postForm"
        :rules="rules"
        ref="postForm"
        label-width="80px"
        class="addForm"
      >
        <el-form-item label="标题" prop="title">
          <el-input v-model="postForm.title" placeholder="请输入标题，标题长度50个字以内" maxlength="50" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="话题">
          <el-select v-model="postForm.topicId" placeholder="请选择话题（此项非必选）" @change="changeTopic" :clearable="clearable">
            <el-option
              v-for="item in topicList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="视频" prop="videoUrl">
          <div v-if="postForm.videoUrl" class="re-uploader">
            <el-button type="primary" plain >
              上传视频
              <input id="file-chooser" type="file" accept="video/*" @change="videoUpload" />
            </el-button>
            <el-progress v-if="percentage>0" class="re-upload-progress" :text-inside="true" :stroke-width="16" :percentage="percentage"></el-progress>
          </div>
          <div class="uploader cl">
            <iframe width="100%" height="100%" v-if="postForm.videoUrl"
              :src="'https://player.dahe.cn/dh_player/?videosrc='+ postForm.videoUrl"
              frameborder="0" allowfullscreen>
            </iframe>
            <template v-else>
              <div class="upload-tips">
                <p>
                  <i class="el-icon-plus avatar-uploader-icon"></i><br />上传视频
                </p>
                <p class="upload-des">请选择视频上传，一次只能上传一个视频</p>
                <el-progress v-if="percentage>0" class="upload-progress" :text-inside="true" :stroke-width="16" :percentage="percentage"></el-progress>

              </div>
              <input id="file-chooser" type="file" accept="video/*" @change="videoUpload" />
            </template>
          </div>
        </el-form-item>
        <el-form-item class="form-center">
          <el-button v-if="isLoading" type="primary" @click="submitForm('postForm')" class="play-btn" disabled>发布</el-button>
          <el-button v-else type="primary" @click="submitForm('postForm')" class="play-btn">发布</el-button>
          <el-button @click="resetForm('postForm')" class="cancel-btn">重置</el-button>
           <!-- <el-button @click="addDraft"  type="warning" plain>保存为草稿</el-button> -->
        </el-form-item>
      </el-form>
    </section>
    <section class="main" v-else>
      <h1 class="tips">请先登录！</h1>
      <div class="login">
        <el-button type="primary" @click="$router.push({path:'/login'})">去登录</el-button>
      </div>
    </section>
  </div>
</template>

<script>
import HeaderBar from "@/components/Header.vue";
import UserHead from "@/components/UserHead.vue";
import VueUeditorWrap from "vue-ueditor-wrap";
export default {
  name: "AddVideo",
  components: {
    HeaderBar,
    UserHead,
    VueUeditorWrap
  },
  data() {
    return {
      userToken: localStorage.getItem("UserToken"),
      channelDataList: [],
      topicList:[],
      postForm: {
        title: "",
        topicId: "",
        content: " ",
        type: 1,
        videoUrl:''
      },
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        topicId: [
          { required: true, message: "请选择话题", trigger: "change" }
        ],
        videoUrl: [{ required: true, message: "请上传视频", trigger: "blur" }]
      },
      currId:'',
      currType:'',
      percentage: 0,
      clearable: true,
      isLoading: false
    };
  },
  methods: {
    getChannels() {
      this.$api
        .channelList({
          type: 0
        })
        .then(res => {
          this.channelDataList = res.data.data;
        });
    },
    getTopics(){
      this.$api.topics()
        .then(res => {
          this.topicList = res.data.data;
        });
    },
    changeTopic(val){
      let obj = this.topicList.find(item=>{
        return item.id == val
      })
      this.postForm.topicName = obj?obj.name:"";
    },
    //上传视频
    videoUpload(){
      let _this = this;
      let credentials = {
          accessKeyId: 'GJUE9A4BXKI5IF7KMSTO',
          secretAccessKey: '9KTAestifl4EdRzY7PGQKpQhZPEoF6AuZvbJ579e'
      };
      //秘钥形式的登录上传
      AWS.config.update(credentials);
      AWS.config.endpoint = 'https://oss.dahe.cn/yydahe'  //url路径说明：http://ip:port/bucket_name
      AWS.config.sslEnabled = false;
      AWS.config.s3BucketEndpoint = true;

      // create bucket instance
      let s3obj = new AWS.S3({params: {Bucket: 'yydahe'}});  //选择桶
      let fileChooser = document.getElementById('file-chooser');
      let file = fileChooser.files[0];
      let filekey = (new Date().getTime()) +''+ parseInt(Math.random()*1000);
      let params = {
          Key: filekey +'.'+ file.name.split('.')[1],
          ContentType: file.type,
          Body: file,
          'Access-Control-Allow-Credentials': '*',
          'ACL': 'public-read'
      };
      //key可以设置为桶的相对路径，Body为文件， ACL可选
      let options = {
          partSize: 10 * 1024 * 1024*100,  // 分片大小, 例：10M
          queueSize: 4,  // 分片上传并发队列， 代表了能同时上传的分片数量
          leavePartsOnError: true
      };
      //s3obj.upload(params, options, function (err, data) {   //分片设置options 设置方式
      s3obj.upload(params, options, function (err, data) {
          console.log(err);
      }).on('httpUploadProgress', function(evt) {
        _this.percentage = parseInt((evt.loaded * 100) / evt.total)
      }).send(function(err, data) {
        _this.postForm.videoUrl = data.Location
        _this.percentage = 0
      });
    },
    submitForm(formName) {
      let _this = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.isLoading = true;
          this.$api[this.currType=='add'?'addPosts':'editPosts'](this.postForm).then(res => {
            window.localStorage.removeItem("formDataVideo")
            this.$message({
              message: res.data.msg,
              type: "success",
              duration: 2000,
              onClose: function(){
                _this.$router.push('/user/personal/'+ JSON.parse(localStorage.getItem("UserInfo")).id)
              }
            });
            this.$refs[formName].resetFields();
          });
          setTimeout(() => {
            this.isLoading = false;
          }, 2000);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.postForm.topicId = '';
    },
    getInfo(){
      this.$api
        .articleDetail({
          id: this.currId
        })
        .then(res => {
          let data = res.data.data;
          let postForm = {
            id: data.id,
            title: data.title,
            content: data.content,
            videoUrl: data.videoUrl.replace("http","https"),
            topicId: data.topicId==0?'':data.topicId,
            topicName: data.topicId==0?'':data.topicName,
            type: 1
          }
          this.postForm = postForm
        });
    },
    addDraft(){
      window.localStorage.setItem("formDataVideo",JSON.stringify(this.postForm))
      this.$message({
          message: '已保存为草稿',
          type: 'success'
      });
    }
  },
  created() {
    this.getChannels();
    this.getTopics();
    let type = this.$route.params.type;
    this.currType = type;
    if(type=="edit"){
      this.currId = this.$route.query.id;
      this.getInfo()
    }else{
      this.postForm = JSON.parse(window.localStorage.getItem("formDataVideo"))||this.postForm;
    }
  }
};
</script>

<style scoped lang="scss">
.main {
  width: 1000px;
  margin: 10px auto;
  background: #fff;
  padding: 26px;
  .title {
    font-size: 18px;
    line-height: 1;
    color: #121212;
    border-left: 4px solid #317DFF;
    padding-left: 10px;
  }
  .tips{
    font-size: 18px;
    line-height: 1;
    color: #121212;
    text-align: center;
    margin-top: 100px;
  }
  .login{
    text-align: center;
    margin-top: 20px;
    margin-bottom: 100px;
    .el-button{
      width: 100px;
      height: 40px;
      background: #317DFF; 
    }
  }
  .addForm {
    margin-top: 20px;
    margin-right: 200px;
    .el-select {
      display: block;
    }
    .uploader {
      width: 100%;
      height: 350px;
      border-radius: 3px;
      border: 1px solid #e5e5e5;
      padding: 9px;
      background: #f7f7f7;
      position: relative;
      .upload-tips {
        text-align: center;
        color: #317DFF;
        line-height: 1.8;
        padding-top: 100px;
        i {
          font-size: 22px;
          font-weight: bold;
        }
        p.upload-des {
          font-size: 12px;
          color: #666666;
          margin-top: 7px;
        }
        .upload-progress{
          width: 80%;
          margin: 30px auto 0;
        }
      }
      #file-chooser{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        cursor: pointer;
        z-index: 5;
        opacity: 0;
      }
    }
    .re-uploader{
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      position: relative;
      #file-chooser{
        position: absolute;
        left: 0;
        top: 0;
        width: 100px;
        height: 100%;
        cursor: pointer;
        z-index: 5;
        opacity: 0;
      }
      .re-upload-progress{
        width: 80%;
        display: inline-block;
        margin-left: 30px;
      }
    }
    .form-center {
      text-align: center;
      .play-btn {
        width: 128px;
        height: 40px;
        background: #317DFF;
        border-radius: 4px;
        border: none;
      }
      .cancel-btn {
        width: 128px;
        height: 40px;
        background: #dddddd;
        border-radius: 4px;
        margin-left: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/addVideo.vue